import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paginator } from '../../../components/common';
import Table from './Table';
const PageableTable = ({ leftControl, loading, rows, columns, sortParams, onSortChange, onPageChange, onSelect, pageSize, setPageSize, selectedPage, setSelectedPage, totalCount, }) => {
    const onPageChangeClient = ({ selected }) => {
        const offset = pageSize * selected;
        const limit = pageSize;
        if (onPageChange) {
            // perform server side paging
            onPageChange({ selected, offset, limit });
        }
        setSelectedPage(selected);
    };
    return (_jsxs("div", { children: [_jsx("div", { className: "grid grid-cols-6 mb-5", children: _jsx("div", { className: "col-start-1 col-end-3", children: leftControl }) }), _jsxs("div", { className: "w-full shadow overflow-hidden border border-gray-200 sm:rounded-lg", children: [_jsx(Table, { loading: loading, onSelect: onSelect, columns: columns, rows: rows, sortParams: sortParams, onSortChange: onSortChange }), _jsx(Paginator, { rowCount: totalCount, pageSize: pageSize, setPageSize: setPageSize, onPageChange: onPageChangeClient, initialPage: 1, selectedPage: selectedPage })] })] }));
};
export default PageableTable;
